// Component wrapper for page tracking
import { usePageTracking } from '../hooks/usePageTracking';

export const PageTracker: React.FC = () => {
  usePageTracking();
  return null;
};
